<template>
    <v-sheet class="defaultCard" color="bgtopology" v-if="finalCAMBIUM.length > 0" >
        <v-row class="ma-0" justify="space-between">
            <span class="titleDashboard"> Cambium </span>
            <v-text-field 
            style="max-width: 400px;"
            v-model="searchValueCAM"
            :label="t('search')"
            variant="outlined"
            density="compact"                      
            hide-details                     
            ></v-text-field>
        </v-row>
        <EasyDataTable
        :search-field="searchFieldCAM"
        :search-value="searchValueCAM"
        table-class-name="customize-table"
        show-index
        :headers="HEADERS"
        :items="finalCAMBIUM"
        :rows-per-page="10"
        >
            <template #item-operation="item">
                <div class="operation-wrapper">
                    <v-icon color="#FC1050" @click="showEditDialog(item.index,'cam',item.name, item.state)" > mdi-pencil-plus </v-icon>
                </div>
            </template>
        </EasyDataTable>
    </v-sheet>

    <v-sheet class="defaultCard" color="bgtopology" v-if="finalMIKROTIK.length > 0">
        <v-row class="ma-0" justify="space-between">
            <span class="titleDashboard"> mikrotik </span>
            <v-text-field 
            style="max-width: 400px;"
            v-model="searchValueMIK"
            :label="t('search')"
            variant="outlined"
            density="compact"                      
            hide-details                     
            ></v-text-field>
        </v-row>
        <EasyDataTable
        :search-field="searchFieldMIK"
        :search-value="searchValueMIK"
        table-class-name="customize-table"
        show-index
        :headers="HEADERS"
        :items="finalMIKROTIK"
        :rows-per-page="10"
        >
            <template #item-operation="item">
                <div class="operation-wrapper">
                    <v-icon color="#FC1050" @click="showEditDialog(item.index,'mik',item.name, item.state)" > mdi-pencil-plus </v-icon>
                </div>
            </template>
        </EasyDataTable>
    </v-sheet>

    <v-sheet class="defaultCard" color="bgtopology" v-if="finalRAJANT.length > 0">
        <v-row class="ma-0" justify="space-between">
            <span class="titleDashboard"> Rajant </span>
            <v-text-field 
            style="max-width: 400px;"
            v-model="searchValueRAJ"
            :label="t('search')"
            variant="outlined"
            density="compact"                      
            hide-details                     
            ></v-text-field>
        </v-row>
        <EasyDataTable
        :search-field="searchFieldRAJ"
        :search-value="searchValueRAJ"
        table-class-name="customize-table"
        show-index
        :headers="HEADERS"
        :items="finalRAJANT"
        :rows-per-page="10"
        >
            <template #item-operation="item">
                <div class="operation-wrapper">
                    <v-icon color="#FC1050" @click="showEditDialog(item.index,'raj',item.name, item.state)" > mdi-pencil-plus </v-icon>
                </div>
            </template>
        </EasyDataTable>
    </v-sheet>

    <v-sheet class="defaultCard" color="bgtopology" v-if="finalCISCO.length > 0">
        <v-row class="ma-0" justify="space-between">
            <span class="titleDashboard"> cisco </span>
            <v-text-field 
            style="max-width: 400px;"
            v-model="searchValueCIS"
            :label="t('search')"
            variant="outlined"
            density="compact"
            hide-details               
            ></v-text-field>
        </v-row>
        <EasyDataTable
        :search-field="searchFieldCIS"
        :search-value="searchValueCIS"
        table-class-name="customize-table"
        show-index
        :headers="HEADERS"
        :items="finalCISCO"
        :rows-per-page="10"
        >
            <template #item-operation="item">
                <div class="operation-wrapper">
                    <v-icon color="#FC1050" @click="showEditDialog(item.index,'cis',item.name, item.state)" > mdi-pencil-plus </v-icon>
                </div>
            </template>
        </EasyDataTable>
    </v-sheet>


    <v-row class="ma-4" justify="end">
        <v-btn color="success" @click="changeYAML"> enviar </v-btn>
    </v-row>

    <v-dialog v-model="showEdit" width="80%">
        <v-sheet color="background" class="defaultCard">
            <span class="subtitleDashboard">Editar el producto </span>
            <br/>
            <v-row class="ma-0 mt-4">
                <v-col class="pa-0 pr-2" cols="6">
                    <v-text-field
                    v-model="nameChange"
                    :label="t('search')"
                    variant="outlined"
                    density="compact"
                    hide-details     
                    />
                </v-col>
                <v-col class="pa-0 pl-2" cols="6">
                    <v-select
                    v-model="status"
                    :items="itemStatus"
                    :label="'status'"
                    variant="outlined"
                    density="compact"
                    hide-details     
                    />
                </v-col>
            </v-row>
            <v-row class="mt-6 mb-2 mx-1" justify="end">
                <v-btn @click="changeInfo" color="success">guardar</v-btn>
            </v-row>
        </v-sheet>
    </v-dialog>

</template>

<script setup  lang="ts">
import { ref, Ref, onMounted } from 'vue';
import { useStore }     from 'vuex';
import axios            from 'axios';
import { useI18n }          from 'vue-i18n';

// CONSTANTS
import CONSTAPIS           from '@/constants/apis';

// COMPONENTS

//INTERFACES
import { YAMLITEMS, YAMLOBJ, finalYAMLOBJ } from '@/interfaces/SmartLink/Equips';
import { HEADER } from '@/interfaces/SmartLink/Tables';
import { TOKEN } from '@/constants/labels';
type FINALYAML = [string, YAMLOBJ];

const { t }                 = useI18n();
const store                 = useStore();
 
const finalCAMBIUM:Ref<YAMLITEMS[]> = ref([]);
const finalCISCO:Ref<YAMLITEMS[]>   = ref([]);
const finalMIKROTIK:Ref<YAMLITEMS[]>= ref([]);
const finalRAJANT:Ref<YAMLITEMS[]>  = ref([]);
const showEdit                      = ref(false);
const index                         = ref(0);
const typed                         = ref('');
const nameChange                    = ref('');
const status                        = ref('false');
const itemStatus                    = ref(['true','false']);

const searchFieldCAM                = ref();
const searchValueCAM                = ref("");
const searchFieldMIK                = ref();
const searchValueMIK                = ref("");
const searchFieldRAJ                = ref();
const searchValueRAJ                = ref("");
const searchFieldCIS                = ref();
const searchValueCIS                = ref("");


const HEADERS:HEADER[]   = [
{ text: 'Valor',        value: "value",       sortable: true, },
{ text: 'Name',         value: "name",        sortable: true, },
{ text: 'Estado',       value: "state",       sortable: true, },          
{ text: 'Edit',         value: "operation",   sortable: false, },          
];

const getYAML = async() => {
    await axios.get(CONSTAPIS.APIS.value.yaml.getYAML, { headers: { "Authorization": `Bearer ${TOKEN}`} }).then((yaml)=> {
    let cambium     = yaml.data.body.CAMBIUM;
    let cisco       = yaml.data.body.CISCO;
    let mikrotik    = yaml.data.body.MIKROTIK;
    let rajant      = yaml.data.body.RAJANT;

    let itemsCAMBIUMPrev :FINALYAML[]   = cambium   ? Object.entries(cambium) : [];
    let itemsCISCOPrev   :FINALYAML[]   = cisco     ? Object.entries(cisco) : [];
    let itemsMIKROTIKPrev:FINALYAML[]   = mikrotik  ? Object.entries(mikrotik) : [];
    let itemsRAJANTPrev  :FINALYAML[]   = rajant    ? Object.entries(rajant) : [];
    
    finalCAMBIUM.value      = getArrayYAML(itemsCAMBIUMPrev);
    finalCISCO.value        = getArrayYAML(itemsCISCOPrev);
    finalMIKROTIK.value     = getArrayYAML(itemsMIKROTIKPrev);
    finalRAJANT.value       = getArrayYAML(itemsRAJANTPrev);
    })
}

const getArrayYAML = (item:FINALYAML[]) => { 
    let memoryYAML:YAMLITEMS[] = []
    item.forEach((item:FINALYAML) => {
        memoryYAML.push({
            value   : item[0],
            name    : item[1].codename,
            state   : item[1].state
        })
    })
    return memoryYAML
}

const showEditDialog = (i:number, type: string, name:string, stat: string) => {
    showEdit.value      = true;
    index.value         = i;
    typed.value         = type;
    nameChange.value    = name;
    status.value        = stat;
}

const closeEditDialog = () => {
    showEdit.value      = false;
    index.value         = 0;
    typed.value         = '';
    nameChange.value    = '';
    status.value        = 'false';
}

const changeInfo = () => {
    if(typed.value === 'cam'){
        finalCAMBIUM.value[index.value-1].name      = nameChange.value;
        finalCAMBIUM.value[index.value-1].state     = status.value;
    }
    if(typed.value === 'raj'){
        finalRAJANT.value[index.value-1].name       = nameChange.value;
        finalRAJANT.value[index.value-1].state      = status.value;
    }
    if(typed.value === 'mik'){
        finalMIKROTIK.value[index.value-1].name     = nameChange.value;
        finalMIKROTIK.value[index.value-1].state    = status.value;
    }
    if(typed.value === 'cis'){
        finalCISCO.value[index.value-1].name        = nameChange.value;
        finalCISCO.value[index.value-1].state       = status.value;
    }
    closeEditDialog();
}

const changeYAML = async() => {
    let finalYAML:finalYAMLOBJ = {
        CAMBIUM     : {},
        CISCO       : {},
        MIKROTIK    : {},
        RAJANT      : {},
    }
    finalCAMBIUM.value.forEach((cambium:YAMLITEMS) => {
        finalYAML.CAMBIUM[cambium.value] = {
            codename    : cambium.name,
            state       : cambium.state
        }
    })
    finalCISCO.value.forEach((cisco:YAMLITEMS) => {
        finalYAML.CISCO[cisco.value] = {
            codename    : cisco.name,
            state       : cisco.state
        }
    })
    finalRAJANT.value.forEach((rajant:YAMLITEMS) => {
        finalYAML.RAJANT[rajant.value] = {
            codename    : rajant.name,
            state       : rajant.state
        }
    })
    finalMIKROTIK.value.forEach((mikrotik:YAMLITEMS) => {
        finalYAML.MIKROTIK[mikrotik.value] = {
            codename    : mikrotik.name,
            state       : mikrotik.state
        }
    })

    let params = { yaml : finalYAML }
    
    await axios.post(CONSTAPIS.APIS.value.yaml.editYAML,params,{ headers: { "Authorization": `Bearer ${TOKEN}`} }).then((yaml)=> {
        if(!yaml.data.error){
            store.dispatch('showSnackBar', {type: 'setSnackEdit', msg: 'YAML modificado'});
        }
    })
}


onMounted(async ()=>{
    await getYAML()
})
 
 </script>